import reduxStore from 'redux/store'
import {setResource, setStepperState} from 'redux/actions';
import {panelsValidationKeys as panelsValidationKeys1} from 'pages/purchaser/MyProcedure/scenes/part1/part1.panels.components'
import {panelsValidationKeys as panelsValidationKeys3} from 'pages/purchaser/MyProcedure/scenes/part3/part3.panels.components'
import {panelsValidationKeys as panelsValidationKeys4} from 'pages/purchaser/MyProcedure/scenes/part4/part4.panels.components'
import {DemandValidationKeys} from "constants/DemandValidation";
import DemandSectionsService from "services/DemandSectionsService";

export default async (sectionId, objectId, closeSection = true) => {
    const panelsValidationKeys = {...panelsValidationKeys1, ...panelsValidationKeys3, ...panelsValidationKeys4};

    const {resources} = reduxStore.getState();
    const demandValidation = resources.demandValidation;
    if (!demandValidation || !demandValidation.find(x => x.section === sectionId)?.validateAfterSave)
        return;

    const sectionIndex = demandValidation.findIndex(x => x.section === sectionId)
    const res = await panelsValidationKeys[DemandValidationKeys[sectionId]](objectId);
    let data = JSON.parse(JSON.stringify(demandValidation));
    data[sectionIndex] = res;

    reduxStore.dispatch(setResource(DemandSectionsService.DEMAND_VALIDATION_RESOURCE_ID, data));

    if (res.status === 'OK' || res.status === 'EMPTY') {
        if (closeSection) {
            reduxStore.dispatch(setStepperState());
        }
    }
}